import classes from "../homePageNew.module.css";

/**
 * Standardized "not available" panel for a single section within the detail
 * pane (score summary, reporting, or a future module's own section) — icon
 * + title + optional description, compact enough to sit inside a bordered
 * box rather than filling the whole pane (see EmptyRecordState for that
 * case). Takes the icon component itself so any section can use its own.
 */
export default function SectionEmptyState({ icon: Icon, title, description }) {
  return (
    <div className={classes.emptyState} style={{ padding: "18px 12px" }}>
      <div className={classes.ic}>
        <Icon size={18} />
      </div>
      <div className={classes.t1}>{title}</div>
      {description && <div className={classes.t2}>{description}</div>}
    </div>
  );
}
